import { Routes, Route } from "react-router-dom";
import MainContainer from "./layout/MainContainer";
import Pages from "./pages";
import Features from "./features";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Dashboard />} />
        <Route path="/manage-users" element={<Pages.ManageUser />} />
        <Route path="/manage-users/detail" element={<Pages.ManageUserDetail />} />
        <Route path="/manage-users/edit" element={<Pages.Edituser />} />
        <Route path="/manage-users/add" element={<Pages.Edituser />} />
        <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
        <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
        <Route path="/manage-subadmin/detail" element={<Pages.SubadminDetail />} />
        <Route path="/manage-subadmin/roles" element={<Pages.ManageSubadminRoles />} />
        <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
        <Route path="/manage-subadmin/roles/detail" element={<Pages.RoleDetail />} />

        <Route path="/manage-notifications" element={<Pages.ManageNotifications />} />
        <Route path="/manage-notifications/add" element={<Pages.AddNotification />} />
        <Route path="/manage-notifications/detail" element={<Pages.NotificationDetail />} />
        <Route path="/recieved-notifications" element={<Pages.RecievedNotifications />} />
        <Route path="/manage-system-settings" element={<Pages.ManageSystemSettings />} />
        <Route path="/manage-system-settings/add-campaign-type" element={<Pages.AddCampaignType />} />
        <Route path="/manage-system-settings/view-field-templates" element={<Pages.ViewFieldTemplates />} />
        <Route path="/manage-cms" element={<Pages.ManageCms />} />
        <Route path="/manage-profile" element={<Pages.ManageProfile />} />
        <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
        <Route path="/manage-profile/change-password" element={<Pages.ChangePassword />} />

        <Route path="/manage-promotions" element={<Pages.ManagePromotion />} />
        <Route path="/manage-promotions/add" element={<Pages.AddPromotion />} />
        <Route path="/manage-promotions/edit" element={<Pages.AddPromotion />} />
        <Route path="/manage-promotions/view" element={<Pages.ViewPromotion />} />
        <Route path="/manage-stores" element={<Pages.ManageStores />} />
        <Route path="/manage-stores/add" element={<Pages.AddStore />} />
        <Route path="/manage-stores/detail" element={<Pages.StoreDetail />} />
        <Route path="/manage-qr-code" element={<Pages.ManageQrCode />} />
        <Route path="/manage-rewards" element={<Pages.ManageRewards />} />
        <Route path="/manage-rewards/add" element={<Pages.AddRewards />} />
        <Route path="/manage-rewards/detail" element={<Pages.RewardsDetail />} />
        <Route path="/manage-transactions" element={<Pages.ManageTransction />} />
        <Route path="/manage-transactions/view" element={<Pages.ViewTransction />} />
        <Route path="/manage-activity-logs" element={<Pages.ManageActivityLogs />} />
        <Route path="/manage-feedback-and-reports" element={<Pages.ManageFeedbackReports />} />
        <Route path="/manage-products" element={<Features.manageproducts />} />
        <Route path="/manage-inventory" element={<Features.ManageInventory />} />
        <Route path="/add-product" element={<Features.addProduct />} />
        <Route path="/manage-products/view" element={<Features.ViewProduct />} />
        <Route path="/manage-customers" element={<Pages.ManageCustomers />} />
        <Route path="/manage-customers/add-customer" element={<Pages.AddCustomer />} />
        <Route path="/manage-customers/view-customer" element={<Pages.ViewCustomer />} />
        <Route path="/manage-customers/customer-timeline" element={<Pages.CustomerTimeline />} />
        <Route path="/manage-customers/view-tier/:tierName" element={<Pages.ViewTier />} />
        <Route path="/manage-customers/view-segment/:segmentName" element={<Pages.ViewSegment />} />
        <Route path="/manage-vendors" element={<Pages.ManageVendors />} />
        <Route path="/manage-vendors/add-vendor" element={<Pages.AddVendor />} />
        <Route path="/manage-vendors/edit-vendor" element={<Pages.EditVendor />} />
        <Route path="/manage-vendors/view-vendor" element={<Pages.ViewVendor />} />
        <Route path="/manage-vendors/view-onboarding" element={<Pages.ViewOnboarding />} />
        <Route path="/manage-vendors/view-milestone" element={<Pages.ViewMilestone />} />
        <Route path="/manage-vendors/view-vendor/view-service" element={<Pages.ViewPurchaseServices />} />
        <Route path="/manage-vendors/view-vendor/view-campaign" element={<Pages.ViewCampaign />} />
        <Route path="/manage-vendors/view-vendor/view-subscription" element={<Pages.ViewVendorSubscription />} />
        <Route path="/manage-vendors/view-vendor/store-information" element={<Pages.StoreInformation />} />
        <Route path="/manage-vendors/view-segment/:segmentName" element={<Pages.ViewVendorSegment />} />
        <Route path="/manage-service-providers" element={<Pages.ManageServiceProviders />} />
        <Route path="/manage-service-providers/add" element={<Pages.AddServiceProvider />} />
        <Route path="/manage-service-providers/view" element={<Pages.ViewServiceProvider />} />
        <Route path="/manage-service-providers/view-onboarding" element={<Pages.ViewSPOnboarding />} />
        <Route path="/manage-categories" element={<Pages.ManageCategories />} />
        <Route path="/manage-categories/manage-sub-categories" element={<Pages.ManageSubCategories />} />
        <Route path="/manage-attributes" element={<Pages.ManageAttributes />} />
        <Route path="/manage-brands" element={<Pages.ManageBrands />} />
        <Route path="/order-management" element={<Pages.OrderManagement />} />
        <Route path="/payments" element={<Pages.Payments />} />
        <Route path="/bouteek-community" element={<Pages.BouteekCommunity />} />
        <Route path="/revenue" element={<Pages.Revenue />} />
        <Route path="/loyalty-points" element={<Pages.LoyaltyPoints />} />
        <Route path="/loyalty-points/add" element={<Pages.AddLoyalty />} />
        <Route path="/discount" element={<Pages.DiscountCoupon />} />
        <Route path="/discount/add" element={<Pages.AddDiscount />} />
        <Route path="/discount/view" element={<Pages.ViewDiscount />} />
        <Route path="/manage-recommended-products" element={<Pages.ManageRecommendedProducts />} />
        <Route path="/subscriptions" element={<Pages.Subscriptions />} />
        <Route path="/subscriptions/edit" element={<Pages.EditSubscription />} />
        <Route path="/subscriptions/view" element={<Pages.ViewSubscription />} />
        <Route path="/ad-banner" element={<Pages.AdBanner />} />
        <Route path="/ad-banner/add" element={<Pages.AddAdBanner />} />
        <Route path="/ad-banner/view" element={<Pages.ViewAdBanner />} />
        <Route path="/customer-support" element={<Pages.CustomerSupport />} />
        <Route path="/ratings" element={<Pages.Ratings />} />
        <Route path="/blogs" element={<Pages.Blogs />} />
        <Route path="/blogs/add" element={<Pages.AddBlog />} />
        <Route path="/fikra-lab-business-report" element={<Pages.FikraLabBusinessReport />} />
        <Route path="/fikra-lab-business-report/view" element={<Pages.ViewBusinessReport />} />
        <Route path="/fikra-lab-form" element={<Pages.CreateFikraForm />} />
        <Route path="/founders-pass" element={<Pages.FoundersPass />} />
        <Route path="/fikra-lab-plans" element={<Pages.FikraLabPlans />} />
        <Route path="/fikra-lab-plans/add" element={<Pages.AddFikraLabPlan />} />
        <Route path="/fikra-lab-features" element={<Pages.FikraLabFeatures />} />
        <Route path="/fikra-lab/founder-pass" element={<Pages.FounderPassSettings />} />
        <Route path="/vendor-landing" element={<Pages.VendorLanding />} />
        <Route path="/home-banners" element={<Pages.HomePageBanners />} />
        <Route path="/ai-growth" element={<Pages.AiInsights />} />
        <Route path="/ai-growth/view" element={<Pages.ViewAiInsightsStatic />} />
        <Route path="/vendor-blogs" element={<Pages.VendorBlogs />} />
        <Route path="/vendor-blogs/view" element={<Pages.ViewVendorBlogs />} />
        <Route path="/pending-approval" element={<Pages.PendingApprovals />} />
        <Route path="/order-management/view" element={<Pages.ViewOrderManagement />} />
        <Route path="/vendor-support" element={<Pages.VendorSupport />} />
        <Route path="/sp-support" element={<Pages.SPSupport />} />
        <Route path="/knowledge-base" element={<Pages.KnowledgeBase />} />
        <Route path="/knowledge-base/add" element={<Pages.AddKnowledgeBase />} />
        <Route path="/video-tutorials" element={<Pages.VideoTutorials />} />
        <Route path="/video-tutorials/add" element={<Pages.AddVideoTutorial />} />
        <Route path="/sp-landing" element={<Pages.ServiceProviderLanding />} />
        <Route path="/chat" element={<Pages.Chat />} />
        <Route path="/manage-collections" element={<Pages.ManageCollections />} />
        <Route path="/manage-collections/view/:id" element={<Pages.ViewCollection />} />

        <Route path="/manage-services" element={<Pages.Services />} />
        <Route path="/manage-services/add" element={<Pages.AddService />} />
        <Route path="/return-refund" element={<Pages.ReturnandRefund />} />
        <Route path="/return-refund/view" element={<Pages.ReturnOrderView />} />
        <Route path="/commissions" element={<Pages.Commissions />} />
        <Route path="/commissions/view" element={<Pages.CommissionBySubscription />} />
        <Route path="/vendor-reviews" element={<Pages.VendorRatings />} />
        <Route path="/delivery-zones" element={<Pages.DeliveryZones />} />
        <Route path="/shipping-rates" element={<Pages.ShippingRates />} />
        <Route path="/logistics-hub" element={<Pages.LogisticHub />} />
        <Route path="/logistics-api" element={<Pages.LogisticAPI />} />
        <Route path="/platform-fees" element={<Pages.PlatformFees />} />
        <Route path="/service-bookings" element={<Pages.ServiceBookings />} />
        <Route path="/pricing-analytics" element={<Pages.PricingAnalytics />} />
        <Route path="/vendor-payouts" element={<Pages.VendorPayouts />} />
        <Route path="/sp-payouts" element={<Pages.ServiceProviderPayouts />} />
        <Route path="/sp-payouts/view-payout" element={<Pages.ViewPayoutSP />} />
        <Route path="/financial-reports" element={<Pages.FinancialReports />} />
        <Route path="/financial-reports/view" element={<Pages.ViewTransactionLogs />} />
        <Route path="/vat-invoicing" element={<Pages.VatInvoicing />} />
        <Route path="/vat-invoicing/view" element={<Pages.ViewInvoice />} />
        <Route path="/vendor-payouts/view-payout" element={<Pages.ViewPayout />} />
        <Route path="/media-library" element={<Pages.MediaLibrary />} />
        <Route path="/home-layout" element={<Pages.HomeLayout />} />
        <Route path="/home-layout/view" element={<Pages.ViewHomeLayout />} />
        <Route path="/manage-groups" element={<Pages.ManageGroups />} />
        <Route path="/manage-groups/tags" element={<Pages.ManageTags />} />
        <Route path="/persona-dashboard" element={<Pages.PersonaDashboard />} />
        <Route path="/persona-dashboard/view" element={<Pages.ViewPersona />} />
        <Route path="/incident-center" element={<Pages.IncidentCenter />} />
        <Route path="/overview" element={<Pages.TrustComplianceOverview />} />
        <Route path="/compliance-policies" element={<Pages.ComlpliancePolicies />} />
        <Route path="/compliance-policies/view" element={<Pages.ViewPolicies />} />
        <Route path="/data-processing" element={<Pages.DataProcessing />} />
        <Route path="/risk-registry" element={<Pages.RiskRegistry />} />
        <Route path="/ai-hub" element={<Pages.AIHub />} />
        <Route path="/cost-analytics" element={<Pages.CostAnalytics />} />
        <Route path="/vendor-credits" element={<Pages.VendorCredits />} />
        <Route path="/vendor-campaigns" element={<Pages.VendorCampaigns />} />
        <Route path="/vendor-comtracts" element={<Pages.VendorContracts />} />
        <Route path="/vendor-comtracts/view" element={<Pages.ViewContract />} />
        <Route path="/vendor-comtracts/edit" element={<Pages.EditContract />} />
        <Route path="/sp-contracts" element={<Pages.ServiceProviderContracts />} />
        <Route path="/sp-contracts/view" element={<Pages.ViewSPContract />} />
        <Route path="/sp-contracts/edit" element={<Pages.EditSPContract />} />
        <Route path="/vendor-health-score" element={<Pages.VendorHealthScore />} />
        <Route path="/customer-health-score" element={<Pages.CustomerHealthScore />} />
        <Route path="/sp-health-score" element={<Pages.SPHealthScore />} />
        <Route path="/vendor-health-score/manage-automation" element={<Pages.ManageAutomation />} />
        <Route path="/ai-command-center" element={<Pages.AICommandCenter />} />
        <Route path="/ai-brain" element={<Pages.AIBrain />} />
        <Route path="/ai-capibilities" element={<Pages.AiCapabilitiesPage />} />
        <Route path="/ai-autonomy" element={<Pages.AIAutonomy />} />
        <Route path="/discount/ai-campaign-builder" element={<Pages.AiCampaignBuilder />} />
        <Route path="/bouteek-branding" element={<Pages.BouteekBranding />} />
        <Route path="/payment-methods" element={<Pages.PaymentMethods />} />
        <Route path="/ai-policies" element={<Pages.AIPolicies />} />
        <Route path="/ai-decisions" element={<Pages.AIDecisions />} />
        <Route path="/ai-reports" element={<Pages.AIReports />} />
        <Route path="/manage-app-intro" element={<Pages.ManageAppIntro />} />
        <Route path="/ai-roi-business-impact" element={<Pages.AIRoiBusinessImpact />} />
        <Route path="/ai-learning-feedback" element={<Pages.AILearningFeedback />} />
        <Route path="/ai-data-sync" element={<Pages.AIDataSync />} />
        <Route path="/ai-subscription-usage" element={<Pages.AISubscriptionUsage />} />
        <Route path="/ai-audit-governance" element={<Pages.AIAuditGovernance />} />
        <Route path="/ai-health-drift" element={<Pages.AIHealthDrift />} />
      </Route>
    </Routes>
  );
};

export default Routing;
